import { reactive } from "vue";
import store from "../../../../store";
import { createLoading } from "../../../../utils/loading";
import { createPage } from "../../../../utils/page";
import { has } from "../../../../utils/menu-context";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/master/lookup";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const onSearch = ({ props, page }) => {
    const { menuContext } = props;
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ props, page });
    return callSearch({ criteria: { ...page, data: [], where: [...where, { name: "group", type: "String", operator: "=", value: "REPORT" }], sort } })
        .then(page => {
            const data = page.data.filter(d =>
                (has({ menuContext, key: "center" }) && d.attribute?.roles?.includes("center"))
                || (has({ menuContext, key: "province" }) && d.attribute?.roles?.includes("province"))
                || (has({ menuContext, key: "customs" }) && d.attribute?.roles?.includes("customs"))
                || (has({ menuContext, key: "fee" }) && d.attribute?.roles?.includes("fee"))
            );
            const pageFilter = { ...page, data }
            state.page = { ...pageFilter, where, sort }
        })
        .finally(() => setIsLoading(false));
};

export const initState = () => {
    state.manages = [];
    state.manageExtras = [];
    state.rowActions = [];
};

export const state = reactive({
    columns: [],
    page: createPage({ options: { page: 0, size: 1000000, sort: [{ name: "seq", type: "ASC" }] } }),
    tableOptions: { search: { activeKey: "Search" } }
});
